var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 16.5C21.4634 16.5 21.9284 16.8233 21.9925 17.3699L22 17.5V19.1708C22 20.9504 20.5915 22.4043 18.8181 22.4992L18.6334 22.5042H5.36237C3.56663 22.5019 2.10071 21.1079 2.00497 19.3536L2 19.1708V17.5C2 16.9422 2.43663 16.5 3 16.5C3.52313 16.5 3.91967 16.8899 3.97365 17.3922L3.97993 17.51L4 19.1708C4.00087 19.8508 4.56051 20.4278 5.23472 20.4937L5.36237 20.5H18.6334C19.3202 20.4996 19.9239 19.9626 19.9934 19.297L20 19.1708L20.0243 17.51C20.0243 16.9522 20.501 16.5 21 16.5ZM12 2.5C12.8719 2.5 13.5875 3.16412 13.6604 4.01015L13.6665 4.15276V11.8804C13.6665 11.9785 13.7333 12.0611 13.8242 12.0859L13.8814 12.0935H16.1667C16.4931 12.0936 16.7895 12.2827 16.9249 12.5774C17.0434 12.8352 17.0196 13.1322 16.8683 13.3663L16.7958 13.4624L12.6291 18.2152C12.4709 18.3961 12.2414 18.5 12 18.5C11.7988 18.5 11.6059 18.4279 11.4556 18.2991L11.3709 18.2152L7.20422 13.4624C6.99016 13.2179 6.93969 12.872 7.07509 12.5774C7.19546 12.3155 7.44299 12.1369 7.72581 12.1004L7.83335 12.0935H10.1186C10.2175 12.0935 10.3008 12.0272 10.3258 11.937L10.3335 11.8804V4.15276C10.3335 3.23996 11.0796 2.5 12 2.5Z",
    fill: "#011C48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.f3f2e952.svg";
export { ForwardRef as ReactComponent };